/**
 * Copyright Mántum All Rights Reserved.
 */
import useOutside from '../../../hooks/useOutside';
import { useRef } from 'react';

import type { Position } from '@mantum/kanela';

type PropTypes = {
    children?: React.ReactNode;
    className?: string;
    onClose?: () => void;
    position?: Position;
    testid?: string;
};

export default function Dropdown(props: PropTypes) {
    const componentRef = useRef<HTMLDivElement>(null);

    useOutside(componentRef, () => {
        if (props.onClose) {
            props.onClose();
        }
    });

    return (
        <div
            className={`absolute z-10 my-2 min-w-[12rem] rounded bg-accent shadow-lg ${props.className}`}
            data-testid={props.testid}
            ref={componentRef}
            style={props.position}
        >
            {props.children}
        </div>
    );
}
